import { useCallback, useEffect, useState } from 'react';

import { EVENT_TYPES, EventType, LeadCreation, Region, REGIONS } from 'shared/topchef.types'


type LeadEditorProps  = {
  submitButtonLabel: string;
  formData: LeadCreation;
  onDataChange: (name: string, value: string) => void;
  onSubmit: (formData: LeadCreation) => void;
};


const LeadEditor = ({submitButtonLabel, formData, onDataChange, onSubmit }: LeadEditorProps) => {

  const [isFormReady, setIsFormReady] = useState<boolean>(false);

  const validateForm = useCallback(() => {
    if (formData.type !== '' && 
      formData.targetDate !== '' && isInFuture(formData.targetDate) &&
      formData.region !== '' && formData.region !== 'unknown' && 
      formData.guests !== 0 && formData.guests !== '' &&
      formData.contactEmailAddress !== '' && 
      formData.contactName !== '' && 
      formData.contactCompany !== '' && 
      formData.description !== '' &&
      (formData.contactMobilePhone !== '' || formData.contactLandlinePhone !== '')    
      ) {
        setIsFormReady(true);
      }
      else {
        setIsFormReady(false);
      }
    }, [formData]);

  useEffect(() => {
    validateForm();
  }, [formData, validateForm]);

  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(formData);
  }


  const handleInputEventChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value} = event.target;
    onDataChange(name, value);
  };

  function isInFuture(input: string): Boolean {
    const now = new Date();
    const tomorrow = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    const date = new Date(input);
    const dateToCompare = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    return dateToCompare >= tomorrow;
  }

  function tomorrow(): string {
    const now = new Date();
    const tomorrow = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    const formattedTomorrow = new Date(tomorrow).toISOString().split("T")[0];
    return formattedTomorrow
  }

  return (
    
    <div className="container p-0">
          <div>
              <div id="event_details_form" className="col-md-12">
                  <h4 className="mb-3">Détails de l'événement</h4>

                  <form id="brief_details_form" onSubmit={handleSubmit}>
                      <div id="details_event_form" className="md-3">
                          <div className="mb-3 row">
                              <div className="col-md-6">
                                  <label htmlFor="brief_event_date" className="form-label">Date de l'événement</label><span className="required-marker">*</span>
                                  <input id="brief_event_date" name="targetDate" data-testid="targetDate" type="date" min={tomorrow()} value={formData.targetDate} className="form-control" required onChange={handleInputEventChange} />
                              </div>
                              <div className="col-md-6">
                                  <label htmlFor="event_type" className="form-label">Type d'événement</label><span className="required-marker">*</span>
                                  <select id="event_type" className="form-select" required name="type" data-testid="type" onChange={handleInputEventChange}  size={1} value={formData.type!}>
                                      <option value="">Sélectionner le type d'événement</option>
                                      {EVENT_TYPES.map((eventType: EventType) => (
                                        <option key={eventType.value} value={eventType.value} >
                                          {eventType.label}
                                        </option>
                                      ))}
                                  </select>
                              </div>
                          </div>
                          <div className="mb-3 row">
                              <div className="col-md-6">
                                  <label htmlFor="brief_date_starting" className="form-label">Heure de début</label>
                                  <input type="time" id="brief_date_starting" className="form-control" name="startTime" onChange={handleInputEventChange} value={formData.startTime} />
                              </div>
                              <div className="col-md-6">
                                  <label htmlFor="brief_date_ending" className="form-label">Heure de fin</label>
                                  <input type="time" id="brief_date_ending" className="form-control" name="endTime" onChange={handleInputEventChange} value={formData.endTime} />
                              </div>
                          </div>
                          <div className="mb-3 row">
                              <div className="col-md-6">
                                  <label htmlFor="brief_guests" className="form-label">Nombre de personnes</label><span className="required-marker">*</span>
                                  <input type="number" id="brief_guests" data-testid="guests" className="form-control" placeholder="combien d'invités ?" required name="guests" onChange={handleInputEventChange} value={formData.guests!} />
                              </div>
                              <div className="col-md-6">
                                  <label htmlFor="brief_budget" className="form-label">Budget total</label>
                                  <input type="number" id="brief_budget" data-testid="budget" min={0} className="form-control" placeholder="Montant HT en €" name="budget" onChange={handleInputEventChange} value={formData.budget!} />
                              </div>
                          </div>
                          <div className="mb-3 row">
                              <div className="col-md-6">
                                  <label htmlFor="brief_zipcode" className="form-label">Ville</label>
                                  <input type="text" id="brief_zipcode" data-testid="city" placeholder="Emplacement souhaité de l'événement" aria-label="Emplacement souhaité de l'événement" className="form-control" name="city" onChange={handleInputEventChange} value={formData.city}/>
                              </div>
                              <div className="col-md-6">
                                <label htmlFor="region" className="form-label">Région</label><span className="required-marker">*</span>
                                <select id="region" name="region" data-testid="region" className="form-select" aria-label="Sélectionnez la région de l'événement" size={1} onChange={handleInputEventChange} value={formData.region!} autoComplete="off">
                                  <option value="">Sélectionnez la région</option>
                                  {REGIONS.map((region: Region) => (
                                    <option key={region.value} value={region.value}>
                                      {region.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                          </div>
                          <div className="mb-3">
                              <label htmlFor="event_details_description" className="form-label">Détails de l'événement</label><span className="required-marker">*</span>
                              <textarea className="form-control" id="event_details_description" data-testid="description" rows={9} placeholder="Parlez-nous de l'événement..." required name="description" onChange={handleInputEventChange} value={formData.description!}></textarea>
                          </div>                      
                      </div>
                      <div id="details_contact_form" className="p-3 bg-light mb-3 rounded">
                          <h5 className="mb-3">Informations Client</h5>
                          <div className="row">
                              <div className="col-md-6">
                                  <label htmlFor="brief_company" className="form-label">Entreprise</label><span className="required-marker">*</span>
                                  <input type="text" id="brief_company" data-testid="contactCompany" className="form-control" placeholder="Nom de l'entreprise" required name="contactCompany" onChange={handleInputEventChange} value={formData.contactCompany} />
                                </div>
                                <div className="col-md-6">
                                  <label htmlFor="brief_contact_name" className="form-label">Nom & Prénom du contact</label><span className="required-marker">*</span>
                                  <input type="text" id="brief_contact_name" data-testid="contactName"  className="form-control" placeholder="Nom Prénom" required name="contactName" onChange={handleInputEventChange} value={formData.contactName} />
                              </div>
                          </div>
                          <div className="row my-3">
                              <div className="col-md-6">
                                  <label htmlFor="brief_contact_mail" className="form-label">Email du contact</label><span className="required-marker">*</span>
                                  <input  type="email" id="brief_contact_mail" data-testid="contactEmailAddress" className="form-control" placeholder="votre adresse@email.com" required name="contactEmailAddress" onChange={handleInputEventChange} value={formData.contactEmailAddress} />
                              </div>
                              <div className="col-md-6">
                                  <label htmlFor="brief_contact_tel" className="form-label">Tél. portable</label>
                                  <input  type="tel" id="brief_contact_tel" autoComplete="tel" data-testid="contactMobilePhone" className="form-control" max="17" maxLength={17} min="10" minLength={10} placeholder="06..." name="contactMobilePhone" onChange={handleInputEventChange} value={formData.contactMobilePhone} />
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-6">
                                  <label htmlFor="brief_contact_tel_fix" className="form-label">Tél. fixe</label>
                                  <input type="tel" id="brief_contact_tel_fix" autoComplete="tel" className="form-control" data-testid="contactLandlinePhone"  max="17" maxLength={17} min="10" minLength={10} placeholder="01..." name="contactLandlinePhone" onChange={handleInputEventChange} value={formData.contactLandlinePhone} />

                              </div>
                          </div>
                      </div>
                      
                    <div className="text-center">
                        <button id="save_brief_details" data-testid="validate-lead" className="btn btn-primary" disabled={!isFormReady}>{submitButtonLabel}</button>
                    </div>
                    
                  </form>
              </div>
              
          </div>
      </div>
  );

}

export default LeadEditor;